var _defs, _ellipse, _ellipse2, _path, _path2, _polygon, _polygon2, _path3, _path4, _polygon3, _path5, _path6, _path7, _path8, _path9, _polygon4, _polygon5, _polygon6, _polygon7, _path0, _path1, _path10, _polygon8, _polygon9, _path11, _path12, _path13, _path14, _polygon0, _path15, _path16, _path17, _path18, _path19, _path20, _rect, _rect2, _circle, _circle2, _circle3, _circle4, _path21, _path22, _path23;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMoneyTransfer(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 559.39 440.09",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 169.54,
    y1: 253.24,
    x2: 172.14,
    y2: 486.54,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#010101",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#010101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 386.37,
    y1: 231.74,
    x2: 389.7,
    y2: 530.35,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 137.23,
    y1: 292.41,
    x2: 110.38,
    y2: 242.25,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 374.99,
    y1: 286.5,
    x2: 394.37,
    y2: 392.54,
    gradientTransform: "matrix(1.18, 0.12, -0.1, 0.99, -25.11, -63.12)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 198.1,
    y1: 324.04,
    x2: 170.53,
    y2: 228.98,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 196.64,
    y1: 282.24,
    x2: 67.56,
    y2: 218.87,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 171.34,
    y1: 259.7,
    x2: 157.55,
    y2: 280.83,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 379.85,
    y1: 287.35,
    x2: 368.85,
    y2: 345.43,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 493.19,
    y1: 202.66,
    x2: 496.12,
    y2: 433.25,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 44.15,
    y1: 276.58,
    x2: 57.8,
    y2: 363.71,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 304.3,
    y1: 182.78,
    x2: 375.15,
    y2: 271.67,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 334.99,
    y1: 209.78,
    x2: 387.35,
    y2: 298.67,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 368.61,
    y1: 257.21,
    x2: 386.63,
    y2: 355.83,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 74.73,
    y1: 241.91,
    x2: 59.47,
    y2: 322.48,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 480.33,
    y1: 231.16,
    x2: 517.29,
    y2: 246.12,
    gradientTransform: "translate(-15.89 36.54) rotate(-4.12)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 496.34,
    y1: 180.85,
    x2: 496.34,
    y2: 245.54,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 485.23,
    y1: 221.31,
    x2: 507.28,
    y2: 221.31,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#fff",
    stopOpacity: 0.23
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#fff",
    stopOpacity: 0.41
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#fff",
    stopOpacity: 0.59
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#fff",
    stopOpacity: 0.74
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#fff",
    stopOpacity: 0.85
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#fff",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#fff",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#fff"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Transfer Money 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M562.1,245.28q-.2,3.57-.53,7.1c-1.69,17.57-5.88,34.82-10.16,51.92-8.51,34-18.23,69.42-41.39,94.81-27.91,30.54-70.46,40.95-110.72,42.38s-80.67-4.65-120.78-.56c-40.64,4.16-80.37,18.72-121.16,17.19a156.22,156.22,0,0,1-58.42-13.81C80.59,436,63.52,424,51.18,407.48c-19.26-25.63-24.7-57.79-27.07-88.65a68.66,68.66,0,0,0-1.32-9h0c-.18-.94-.4-1.87-.65-2.81C18.45,292.67,11,280.26,6.57,266.54c-.78-2.44-1.5-4.91-2.06-7.47a60.93,60.93,0,0,1-1.22-18.85c1.66-17.35,8-33.88,14.5-50.11,2.88-7.22,5.85-14.47,9.07-21.6,7.78-17.19,17.1-33.6,30.6-46.92,27.07-26.69,67-36.85,105.25-41.73s77.74-5.72,114.06-18.47c37.6-13.22,71.14-38.92,111-42.76,29.13-2.78,58.36,6.75,83.4,21.41,55.32,32.29,85.83,110.47,90.61,175.7A229.24,229.24,0,0,1,562.1,245.28Z",
    transform: "translate(-3.03 -18.15)",
    fill: "#2c7be5",
    opacity: 0.24,
    style: {
      isolation: "isolate"
    }
  }), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 170.24,
    cy: 315.76,
    rx: 74.68,
    ry: 14.28,
    opacity: 0.26,
    fill: "url(#linear-gradient)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 387.26,
    cy: 311.76,
    rx: 92.8,
    ry: 18.28,
    opacity: 0.26,
    fill: "url(#linear-gradient-2)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M148.94,277.84a116.37,116.37,0,0,1-13.18-1.25,12.65,12.65,0,0,0-3.36-.22,14.21,14.21,0,0,0-4,1.37,41,41,0,0,1-24.28,2.62c-1.56-.31-3.25-.82-4.08-2.17a5.84,5.84,0,0,1-.67-2.36,38.87,38.87,0,0,1-.17-7.85,10.48,10.48,0,0,1,1-4.25,8.3,8.3,0,0,1,3.47-3.14c5.23-2.8,11.54-2,17.47-1.82,7,.25,14.25-.35,21,1.57,4.8,1.35,9.52,4.33,12.09,8.71C157.31,274.19,155,278.08,148.94,277.84Z",
    transform: "translate(-3.03 -18.15)",
    fill: "#fdb386"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M148.94,277.84a116.37,116.37,0,0,1-13.18-1.25,12.65,12.65,0,0,0-3.36-.22,14.21,14.21,0,0,0-4,1.37,41,41,0,0,1-24.28,2.62c-1.56-.31-3.25-.82-4.08-2.17a5.84,5.84,0,0,1-.67-2.36,38.87,38.87,0,0,1-.17-7.85,10.48,10.48,0,0,1,1-4.25,8.3,8.3,0,0,1,3.47-3.14c5.23-2.8,11.54-2,17.47-1.82,7,.25,14.25-.35,21,1.57,4.8,1.35,9.52,4.33,12.09,8.71C157.31,274.19,155,278.08,148.94,277.84Z",
    transform: "translate(-3.03 -18.15)",
    fill: "url(#linear-gradient-3)"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "302.97 280.75 338.17 305.68 454.35 306.56 421.78 283.39 302.97 280.75",
    fill: "#2c7be5"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "316.17 281.71 343.26 300.9 432.64 301.58 407.58 283.75 316.17 281.71",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M290.31,219s28.6-14.08,38.28-36.52l30.81,9.68s-33,44-45.77,45.32Z",
    transform: "translate(-3.03 -18.15)",
    fill: "#2c7be5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M319.79,244.91c1.76-1.1,27.72-9.68,38.51-30.14l26.18,13.86s-25.74,34.77-48.85,35.87Z",
    transform: "translate(-3.03 -18.15)",
    fill: "#2c7be5"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "409.46 261.97 428.82 283.98 357.54 292.19 348.44 276.05 409.46 261.97",
    fill: "#2c7be5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M361.09,292.19l46.2-8.92s2.15,2,6.59,2l8.17,9.47S419.62,298,421,300l-51.17,7.23s-3.93-2.4-7.34-2.31l-6-8.73S361.92,295.6,361.09,292.19Z",
    transform: "translate(-3.03 -18.15)",
    fill: "url(#linear-gradient-4)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M248.56,252.27l-1.89-7.39c-1.19-4.26-4.46-.55-8.44,1.37l-112,54a7.1,7.1,0,0,0-3.83,7.94l1.44,6.39a7.05,7.05,0,0,0,2.58,4.05l18.67,14.42a7.09,7.09,0,0,0,8.73-.06l92.31-73.28A7.08,7.08,0,0,0,248.56,252.27Z",
    transform: "translate(-3.03 -18.15)",
    fill: "#2c7be5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M248.56,252.27l-1.89-7.39c-1.19-4.26-4.46-.55-8.44,1.37l-112,54a7.1,7.1,0,0,0-3.83,7.94l1.44,6.39a7.05,7.05,0,0,0,2.58,4.05l18.67,14.42a7.09,7.09,0,0,0,8.73-.06l92.31-73.28A7.08,7.08,0,0,0,248.56,252.27Z",
    transform: "translate(-3.03 -18.15)",
    fill: "url(#linear-gradient-5)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M124.86,299.69l82.77-67.88a3.69,3.69,0,0,1,3.47-.65l33.15,10.74a3.68,3.68,0,0,1,1.13,6.4l-93.85,73.24a3.68,3.68,0,0,1-4.43.07L125,305.51A3.69,3.69,0,0,1,124.86,299.69Z",
    transform: "translate(-3.03 -18.15)",
    fill: "#2c7be5"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M124.86,299.69l82.77-67.88a3.69,3.69,0,0,1,3.47-.65l33.15,10.74a3.68,3.68,0,0,1,1.13,6.4l-93.85,73.24a3.68,3.68,0,0,1-4.43.07L125,305.51A3.69,3.69,0,0,1,124.86,299.69Z",
    transform: "translate(-3.03 -18.15)",
    fill: "url(#linear-gradient-6)"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "237.04 231.01 234.76 232.79 153.42 296.16 129.04 280.06 127.54 279.06 200.28 219.13 237.04 231.01",
    fill: "#fff"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "234.76 232.79 153.42 296.16 129.04 280.06 200.06 221.57 234.76 232.79",
    fill: "#2c7be5",
    opacity: 0.13
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    points: "175.5 277.77 149.09 264.07 157.19 256.95 183.6 270.64 175.5 277.77",
    fill: "#2c7be5"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    points: "175.5 277.77 149.09 264.07 157.19 256.95 183.6 270.64 175.5 277.77",
    fill: "url(#linear-gradient-7)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M233.81,228.51l-2.88-1.23a58.21,58.21,0,0,1,3-5.71l2.71,1.57A52.48,52.48,0,0,0,233.81,228.51Z",
    transform: "translate(-3.03 -18.15)",
    fill: "#2c7be5"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M242.69,214.15l-2.46-1.93a72.62,72.62,0,0,1,7.65-8.36l2.13,2.29A68.94,68.94,0,0,0,242.69,214.15Zm15.86-14.59-1.66-2.65a50.41,50.41,0,0,1,10.29-5l1,3A48.09,48.09,0,0,0,258.55,199.56Zm30.82-6.73a48.25,48.25,0,0,0-10.72-.21l-.3-3.11a52.13,52.13,0,0,1,11.42.21Z",
    transform: "translate(-3.03 -18.15)",
    fill: "#2c7be5"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M305.69,197.36c-1.91-.8-3.84-1.52-5.74-2.13l1-3c2,.64,4,1.39,6,2.23Z",
    transform: "translate(-3.03 -18.15)",
    fill: "#2c7be5"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    points: "303.85 290.72 302.97 280.75 338.17 305.68 454.35 306.56 452.07 312.8 334.8 313.46 303.85 290.72",
    fill: "#2c7be5"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    points: "303.85 290.72 302.97 280.75 338.17 305.68 454.35 306.56 452.07 312.8 334.8 313.46 303.85 290.72",
    fill: "url(#linear-gradient-8)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M513.65,235.19c-.13,3.94-.35,7.87-.6,11.81-.12,2.25-.28,4.47-.47,6.72-.12,1.66-.43,3.6-1.87,4.38a2.75,2.75,0,0,1-.63.25,7.87,7.87,0,0,1-2.12.09l-9.79-.65a48.77,48.77,0,0,0-9.59,0c-6.32.81-12.13,4.06-18.44,4.78a46.93,46.93,0,0,1-8.38-.06l-25.67-1.69a18.68,18.68,0,0,1-6.43-1.22,6.29,6.29,0,0,1-4-4.84c-.16-1.54.43-3.07.31-4.63a.42.42,0,0,0,0-.19c-.44-4.16-5.91-7.53-4.25-11.38.37-.9,1.15-1.68,1.18-2.65a3.81,3.81,0,0,0-.84-2.16c-1.44-2.31-2.81-5-2.22-7.69.44-1.91,1.81-3.63,1.75-5.56-.09-2.22-2-4-2.25-6.19s1.47-4.53,3.59-5.54a17,17,0,0,1,6.88-1.15l12.32-.38c2-.06,4.28-.18,5.78-1.59,1.81-1.69,1.78-4.6,1-6.91s-2.25-4.38-3-6.72a12.24,12.24,0,0,1,2.19-11.16,4,4,0,0,1,1.59-1.28c2.22-.81,4.07,1.81,5,4a72.34,72.34,0,0,0,14.63,21.63,57.53,57.53,0,0,0,28.13,15c3.09.68,7.59.25,11.16.75a9.42,9.42,0,0,1,3,.84C515.71,223.81,513.77,231.59,513.65,235.19Z",
    transform: "translate(-3.03 -18.15)",
    fill: "#fdb386"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M562.1,245.28c0,.82-.1,1.63-.16,2.44-.09,1.56-.22,3.13-.37,4.66a11.15,11.15,0,0,1-2.47,4.06c-2.82,2.75-7,3-10.79,3q-18.19.24-36.38-1c-.63,0-1.25-.1-1.85-.16a9.83,9.83,0,0,1-4.65-1.56c-2.91-2.1-3.69-6.16-4.22-9.82-1.07-7.06-2.13-14.38-.44-21.32a7.85,7.85,0,0,1,.72-2.09,4.35,4.35,0,0,1,1.31-1.69,6.27,6.27,0,0,1,3.53-.84c.78,0,1.57,0,2.35,0,8.87-.1,17.75.78,26.63.59a71.71,71.71,0,0,0,14.82-1.69c2.37-.53,8.34-3.91,11.62-4.16A229.24,229.24,0,0,1,562.1,245.28Z",
    transform: "translate(-3.03 -18.15)",
    fill: "#fdb386"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M561.94,247.72c-.09,1.56-.22,3.13-.37,4.66a11.15,11.15,0,0,1-2.47,4.06c-2.82,2.75-7,3-10.79,3q-18.19.24-36.38-1c-.63,0-1.25-.1-1.85-.16a7.87,7.87,0,0,1-2.12.09l-9.79-.65a48.77,48.77,0,0,0-9.59,0c-6.32.81-12.13,4.06-18.44,4.78a46.93,46.93,0,0,1-8.38-.06l-25.67-1.69a18.68,18.68,0,0,1-6.43-1.22,6.29,6.29,0,0,1-4-4.84c-.16-1.54.43-3.07.31-4.63a.42.42,0,0,0,0-.19c5.31,4.63,13.09,4.66,20.19,4.44,12.32-.37,24.73-.75,36.67-3.78a10.66,10.66,0,0,1,1.75-11c1.12-1.28,2.56-2.25,3.78-3.43,2.59-2.57,4.06-6,6.44-8.82a10.28,10.28,0,0,1,6.69-3.78,5.84,5.84,0,0,1,2.9.53c3.76,1.81,4.13,6.94,3.91,11.1s-.09,9.19,3.53,11.28a5.93,5.93,0,0,0,1.22.53,15.43,15.43,0,0,0,4.19.53c11.35.29,22.7.25,34.07-.06A67.22,67.22,0,0,1,561.94,247.72Z",
    transform: "translate(-3.03 -18.15)",
    fill: "url(#linear-gradient-9)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M112.64,243.44a54.11,54.11,0,0,1,20.29,1A46.57,46.57,0,0,1,146.8,251a79.46,79.46,0,0,1,27,30.76c.91,1.86,1.57,4.5-.14,5.67-1.47,1-3.42,0-4.88-1-6.37-4.36-27.69-26-42.95-18.95-.42,3.28,3.82,9.77,4.33,13,.45,2.93-1.9,5.7-4.67,6.75s-5.83.78-8.77.47c-8.44-.88-16.85.06-25.34-.14-19.82-.45-32.15-14.72-31-22.16C61.43,259.25,77,247.85,112.64,243.44Z",
    transform: "translate(-3.03 -18.15)",
    fill: "#fdb386"
  })), _polygon0 || (_polygon0 = /*#__PURE__*/React.createElement("polygon", {
    points: "336.41 264.03 390.98 246.13 408.58 268.13 346.54 283.1 336.41 264.03",
    fill: "#2c7be5"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M76.56,277.2A27.49,27.49,0,0,1,72,287.67a16.18,16.18,0,0,0-7.73.31c-3.78,1-7.5,3-11,4.85a266.91,266.91,0,0,1-26.07,12.28c-1.65.69-3.37,1.35-5.12,1.91-2.22-8.75-5.88-16.76-9.38-24.79a165.18,165.18,0,0,1-6.16-15.69c-.78-2.44-1.5-4.91-2.06-7.47C18.79,253.19,42,257.54,54.15,255a94.11,94.11,0,0,0,10.12-2.9,76.29,76.29,0,0,1,10.82-3C76.84,258.29,78.47,268.32,76.56,277.2Z",
    transform: "translate(-3.03 -18.15)",
    fill: "#2c7be5"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M76.56,277.2A27.49,27.49,0,0,1,72,287.67c-6.47-1.44-12.88,2-18.7,5.16a266.91,266.91,0,0,1-26.07,12.28c-1.65.69-3.37,1.35-5.12,1.91-2.22-8.75-5.88-16.76-9.38-24.79A43.9,43.9,0,0,0,30,284.61c8.44-.38,16.69-2.44,25-4C62.15,279.2,69.37,278.2,76.56,277.2Z",
    transform: "translate(-3.03 -18.15)",
    fill: "url(#linear-gradient-10)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M333.14,186.68l15.07,5.06s-2,4.73.44,6.93c0,0-17.27,25.41-31.79,31.57,0,0-2.09-2.31-8.69-1.65l-10.35-7.81s3.86-1.87,3-4.84c0,0,20.79-10.56,26.51-24.64C327.31,191.3,333.14,192.18,333.14,186.68Z",
    transform: "translate(-3.03 -18.15)",
    fill: "url(#linear-gradient-11)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M362.28,221.08,375,227.21s-2.27,4-.37,6.17c0,0-18.06,20.56-31.57,24.4,0,0-1.6-2.27-7.5-2.41l-8.28-8s3.61-1.23,3.16-4c0,0,19.53-7,26.14-18.85C356.62,224.52,361.67,225.94,362.28,221.08Z",
    transform: "translate(-3.03 -18.15)",
    fill: "url(#linear-gradient-12)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M349.2,281.73l38.29-12.1a7.55,7.55,0,0,0,5.72,1.32l7.7,8.58s-1.76,3.52-.44,5.28l-42.61,10.93s-3.52-2-6.39-1.54l-5.79-8.07S350.19,285,349.2,281.73Z",
    transform: "translate(-3.03 -18.15)",
    fill: "url(#linear-gradient-13)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M76.56,277.2A27.49,27.49,0,0,1,72,287.67a16.18,16.18,0,0,0-7.73.31V252.1a76.29,76.29,0,0,1,10.82-3C76.84,258.29,78.47,268.32,76.56,277.2Z",
    transform: "translate(-3.03 -18.15)",
    fill: "url(#linear-gradient-14)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 492.22,
    y: 218.53,
    width: 15.62,
    height: 41.2,
    rx: 3.72,
    transform: "translate(15.44 -53.45) rotate(4.12)",
    fill: "#2c7be5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 492.22,
    y: 218.53,
    width: 15.62,
    height: 41.2,
    rx: 3.72,
    transform: "translate(15.44 -53.45) rotate(4.12)",
    fill: "url(#linear-gradient-15)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 496.34,
    cy: 221.23,
    r: 12.87,
    fill: "#2c7be5"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 496.34,
    cy: 221.23,
    r: 12.87,
    fill: "url(#linear-gradient-16)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 496.25,
    cy: 221.31,
    r: 11.03,
    fill: "#2c7be5"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 496.25,
    cy: 221.31,
    r: 11.03,
    fill: "url(#linear-gradient-17)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M476.41,175.27v-3.69a10.55,10.55,0,0,1-5.58-1.6l.87-2.44A9.79,9.79,0,0,0,477,169.1c2.59,0,4.34-1.49,4.34-3.57s-1.43-3.25-4.12-4.34c-3.73-1.46-6-3.14-6-6.31s2.15-5.33,5.5-5.88v-3.68h2.27v3.54a9.7,9.7,0,0,1,4.74,1.27l-.91,2.41a8.81,8.81,0,0,0-4.6-1.24c-2.81,0-3.87,1.68-3.87,3.14,0,1.9,1.35,2.84,4.53,4.16,3.75,1.53,5.65,3.43,5.65,6.67,0,2.89-2,5.58-5.76,6.2v3.8Z",
    transform: "translate(-3.03 -18.15)",
    fill: "#2c7be5"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M405.87,194.25v-2a5.68,5.68,0,0,1-3-.86l.47-1.31a5.2,5.2,0,0,0,2.82.84c1.39,0,2.33-.8,2.33-1.91s-.77-1.75-2.22-2.33c-2-.79-3.22-1.69-3.22-3.39a3.21,3.21,0,0,1,2.95-3.15v-2h1.21v1.9a5.27,5.27,0,0,1,2.55.69l-.49,1.29a4.66,4.66,0,0,0-2.47-.67c-1.5,0-2.07.9-2.07,1.69,0,1,.72,1.52,2.42,2.23,2,.82,3,1.84,3,3.58a3.4,3.4,0,0,1-3.09,3.32v2Z",
    transform: "translate(-3.03 -18.15)",
    fill: "#2c7be5"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M473.11,292.87v-2a5.72,5.72,0,0,1-3-.86l.47-1.31a5.22,5.22,0,0,0,2.82.84c1.39,0,2.33-.8,2.33-1.92s-.77-1.74-2.21-2.33c-2-.78-3.23-1.68-3.23-3.38a3.21,3.21,0,0,1,2.95-3.16v-2h1.22v1.9a5.27,5.27,0,0,1,2.54.68l-.49,1.29a4.77,4.77,0,0,0-2.46-.66c-1.51,0-2.08.9-2.08,1.68,0,1,.72,1.53,2.43,2.23,2,.82,3,1.84,3,3.58a3.4,3.4,0,0,1-3.09,3.33v2Z",
    transform: "translate(-3.03 -18.15)",
    fill: "#2c7be5"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoneyTransfer);
export default __webpack_public_path__ + "static/media/money-transfer.192e718a26700b771e971c334eded204.svg";
export { ForwardRef as ReactComponent };